import { PipeTransform, Injectable, Pipe } from '@angular/core';
@Pipe({
    name: 'currencyFormat'
})
@Injectable()
export class CurrencyFormatPipe implements PipeTransform {
    constructor() { }
    transform(item: any): any {
        if (item == null) return "";
        item = "$ " + new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, minimumIntegerDigits: 1 }).format(item);
        return item;
    }
}
